import { Context } from '@/models/order-history/status/context/context'
import { OrderStatusViewModel } from '@spa/components/organisms/mypage/order/model/order-status-view'

export abstract class CreateOrderStatusViewModelCommand<T extends Context> {
  execute(context: T): OrderStatusViewModel {
    if (!this.shouldApply(context)) {
      throw new Error(`This command should not be executed.`)
    }

    return this.createViewModel(context)
  }
  abstract shouldApply(context: Context): context is T
  protected abstract createViewModel(context: T): OrderStatusViewModel
}
